import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { MDSButton } from "@/mds";
import { clientEnvModule } from "@/modules/client-env";
import { logger } from "@/modules/logger";
import { windowModule } from "@/modules/window";
import styled from "@emotion/styled";
import { MDSText, MDSTextVariant } from "@/mds";
import { DateTime } from "luxon";
import { useState } from "react";
import { VersionNoticeCard } from "./VersionNoticeCard";

export const AppVersionHandling = () => {
  const [reloadRequired, setReloadRequired] = useState(false);

  useEffectOnMount(() => {
    const myBuildDate = clientEnvModule.buildInfo().buildInfo.buildTimestamp;
    const myBuildInfo = myBuildDate.toISO();
    logger.info({
      message: `[app-version] Current build: ${myBuildInfo}`,
    });

    const channel = new BroadcastChannel("app-version");
    channel.postMessage({ buildInfo: myBuildInfo });

    channel.onmessage = event => {
      const { buildInfo } = event.data;
      if (!buildInfo) return;

      const buildDate = DateTime.fromISO(buildInfo);
      if (buildDate.diff(myBuildDate).days < 7) return;

      logger.info({
        message: `[app-version] Newer build available: ${buildInfo}`,
      });
      setReloadRequired(true);
    };
    return () => channel.close();
  });

  if (!reloadRequired) return null;

  return (
    <VersionNoticeCard>
      <MDSText variant={MDSTextVariant.TextXs}>
        A new version of Mem is available.
        <br />
        Please reload to continue.
      </MDSText>
      <ReloadButton onClick={() => windowModule.forceReload()}>Reload</ReloadButton>
    </VersionNoticeCard>
  );
};

const ReloadButton = styled(MDSButton)({
  alignSelf: "flex-end",
});
